// src/pages/EventRegisterLanding.js
// The "without the website layout" option: a standalone, full-screen landing
// page for an event. It reuses the EXACT same registration logic (RegistrationCore)
// but renders its own minimal chrome (its own header/footer), so it must be wired
// in the router OUTSIDE the shared <Layout> wrapper. See router-additions.js.
import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { RegistrationCore } from "./EventRegister";

export default function EventRegisterLanding() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();

  // Keep RTL behaviour consistent with the rest of the site.
  React.useEffect(() => {
    document.body.dir = i18n.language === "ar" ? "rtl" : "ltr";
    return () => { document.body.dir = "ltr"; };
  }, [i18n.language]);

  // No use_layout check here: RegistrationCore below receives
  // layout="standalone" and handles it from the single fetch it already
  // makes. Doing it here as well meant two requests for the same event and
  // two components racing to navigate.

  return (
    <div style={{ minHeight: "100vh", background: "#f3f8f4", display: "flex", flexDirection: "column" }}>
      <Helmet>
        <title>{t("reg.title", "Inscription")}</title>
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
      </Helmet>

      {/* Minimal standalone header */}
      <header
        style={{
          background: "linear-gradient(135deg,#155632 0%,#1c7041 55%,#2f9d63 130%)",
          color: "#fff",
          padding: "18px 0",
          boxShadow: "0 4px 18px rgba(28,112,65,.25)",
        }}
      >
        <div className="container d-flex align-items-center justify-content-between">
          <span className="fw-bold fs-5">
            <i className="bi bi-mortarboard me-2"></i>{t("menu.caci", "CACI")}
          </span>
          {/* Language switch (path-based, like the rest of the app) */}
          <div className="btn-group btn-group-sm">
            {["fr", "ar", "en"].map((lng) => (
              <a
                key={lng}
                className={`btn ${i18n.language === lng ? "btn-light" : "btn-outline-light"}`}
                href={lng === "fr" ? `/e/${slug}` : `/${lng}/e/${slug}`}
              >
                {lng.toUpperCase()}
              </a>
            ))}
          </div>
        </div>
      </header>

      <main style={{ flex: 1 }}>
        <RegistrationCore slug={slug} layout="standalone" />
      </main>

      <footer style={{ background: "#0b1220", color: "#94a3b8", padding: "18px 0", textAlign: "center" }}>
        <div className="container">
          <small>© {new Date().getFullYear()} {t("menu.caci", "CACI")} — {t("reg.title", "Inscription")}</small>
        </div>
      </footer>
    </div>
  );
}